module.exports = __webpack_public_path__ + "img/ezp_black.fe974bd8.png";